import {PolymerElement, html} from '@polymer/polymer';
import '@polymer/polymer/lib/elements/dom-if.js';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';
import {FieldcontainerSharedStylesHTML} from '../shared-styles/field-container.js';

class KeliInlineSection extends ScopeBinding(PolymerElement) {
  static get template() {
    return html`
${FieldcontainerSharedStylesHTML}
<style>
:host {
  display: inline-block;
}

#sectionTitle {
  font-weight: 300;
  font-size: 1.1em;
  text-align: left;
  margin: .8em 0 0 0;
  color: var(--keli-header-color);
}
</style>

<template is="dom-if" if="[[caption]]">
  <keli-header id="sectionTitle" caption="[[caption]]"></keli-header>
</template>
<slot></slot>`;
  }

  static get is() {
    return 'keli-inline-section';
  }

  static get properties() {
    return {
      caption: {type: String, scopevar: true},
      isRegionElement: {type: Boolean, value: true},
      keliControlTypes: {type: Array, value: ['inlinesection']}
    }
  }
}

customElements.define(KeliInlineSection.is, KeliInlineSection);
export {KeliInlineSection};
